exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart-row-quantity{display:flex;flex-direction:column;align-items:flex-end}", ""]);

// exports
